import { initWabunkaDataLayer } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';
import { installWabunkaGtmZonesGuard } from '@/wabunka-src/common/utils/googleAnalytics/gtmZonesGuard';
import { registerWabunkaPageViewTracking } from '@/wabunka-src/common/utils/googleAnalytics/pageView';

/**
 * GTM 送信の基盤。vue-gtag が担っていた dataLayer の生成と page_view の自動送信を引き継ぐ。
 *
 * dataLayer をここで作るのは、ssr: false のルートでは GTM スニペットがクライアント注入となり、
 * 生成が page mount に間に合わず purchase を取りこぼすため。
 */
export default defineNuxtPlugin(() => {
  // 初回 page_view も守備範囲に入れるため、送信を始める前に設置する
  installWabunkaGtmZonesGuard();
  initWabunkaDataLayer();

  // await せず投げっぱなしにするのは、plugin の解決を待たせると router の初期解決と待ち合う恐れがあるため
  registerWabunkaPageViewTracking(useRouter(), () => window.location.href);
});
